<div class="top-bar-user d-flex" (click)="tieredMenu.toggle($event)">
  <div class="top-bar-user_container d-flex"
       pTooltip="<div>{{title}}</div><div>{{subtitle}}</div>"
       tooltipPosition="left"
       tooltipStyleClass="no-max-width"
       [escape]="false">
    <div class="top-bar-user_container_info d-flex flex-column justify-content-center">
      <div class="top-bar-user_container_info_title">
        <span>{{title}}</span>
      </div>
      <div class="top-bar-user_container_info_subtitle">
        <span>{{subtitle}}</span>
      </div>
    </div>
    <div>
      <!--TODO alert component-->
    </div>
  </div>
</div>
<p-tieredMenu #tieredMenu [model]="items" [popup]="true"
              styleClass="tiered-menu_open-content-to-left"
></p-tieredMenu>
